import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import { OrderPayload, PoojaOrder, ChadhavaOrdersV2, SubscriptionOrdersResponse, Response } from './types'

class OrdersApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getOrders = (
    pageNo: string,
    orderStatus: string,
    serviceType: string,
    bookingId: string,
    contactNumber: string,
    userId: string,
    storeId: string,
    bookingWhatsapp: string,
    bookingMemberData: string,
    deliveryStatus: string,
    bookingAddress: string,
  ) => {
    return this.api.get<PoojaOrder>(`yoda/internal/v1/orders`, {
      params: {
        page_no: pageNo,
        order_status: orderStatus,
        ...(serviceType && { service_type: serviceType }),
        ...(bookingId && { booking_id: bookingId }),
        ...(contactNumber && { contact_number: contactNumber }),
        ...(userId && { user_id: userId }),
        ...(storeId && { store_id: storeId }),
        ...(bookingWhatsapp && { booking_whatsapp_number: bookingWhatsapp }),
        ...(bookingMemberData && { booking_member_data: bookingMemberData }),
        ...(deliveryStatus && { delivery_status: deliveryStatus }),
        ...(bookingAddress && { booking_address: bookingAddress }),
      },
    })
  }

  getOrdersV2 = (
    pageNo: string,
    orderStatus: string,
    serviceType: string,
    bookingId: string,
    contactNumber: string,
    userId: string,
    storeId: string,
    bookingWhatsapp: string,
    bookingMemberData: string,
    deliveryStatus: string,
    bookingAddress: string,
  ) =>
    this.api.get<ChadhavaOrdersV2>(`/gw2/yoda/internal/v2/orders`, {
      params: {
        page_no: pageNo,
        order_status: orderStatus,
        ...(serviceType && { service_type: serviceType }),
        ...(bookingId && { booking_id: bookingId }),
        ...(contactNumber && { contact_number: contactNumber }),
        ...(userId && { user_id: userId }),
        ...(storeId && { store_id: storeId }),
        ...(bookingWhatsapp && { booking_whatsapp_number: bookingWhatsapp }),
        ...(bookingMemberData && { booking_member_data: bookingMemberData }),
        ...(deliveryStatus && { delivery_status: deliveryStatus }),
        ...(bookingAddress && { booking_address: bookingAddress }),
      },
    })

  updateOrder = (orderId: string, action: string, payload: any) =>
    this.api.patch(
      `gw1/yoda/internal/v1/orders/${orderId}/${action}`,
      payload,
      {
        headers: { 'x-afb-platform': 'web' },
      },
    )

  // Chadhava refund API
  createRefund = (orderId: string, payload: OrderPayload) =>
    this.api.post(
      `/gw2/yoda/internal/v1/orders/order/${orderId}/refund`,
      payload,
      {
        headers: { 'x-afb-platform': 'web' },
      },
    )

  getSubscriptionOrders = (
    orderStatus: string,
    bookingId: string,
    contactNumber: string,
    userId: string,
    bookingWhatsapp: string,
  ) =>
    this.api.get<Response<SubscriptionOrdersResponse>>(`/gw2/yoda/internal/v2/subscription/orders`, {
      params: {
        order_status: orderStatus,
        ...(bookingId && { booking_id: bookingId }),
        ...(contactNumber && { contact_number: contactNumber }),
        ...(userId && { user_id: userId }),
        ...(bookingWhatsapp && { booking_whatsapp_number: bookingWhatsapp }),
      },
    })

  // Cancel subscription API
  cancelSubscription = (bookingId: number, remarks: string) =>
    this.api.post(
      `gw2/yoda/internal/v2/cancel-subscription/${bookingId}`,
      { remarks: remarks },
      {
        headers: { 'x-afb-platform': 'web' },
      },
    )
}

export default OrdersApi
